import * as EmotionTheming from 'emotion-theming'
import * as React from 'react'
import * as ReactRouter from 'react-router-dom'

import * as Common from '@rushplay/common'
import * as I18n from '@rushplay/i18n'

import * as Theming from '../theming'
import { Card } from '../card'
import { HtmlContent } from '../html-content'
import { SupportChatActionButton } from '../support-chat-action-button'

export function FaqPage() {
  const i18n = I18n.useI18n()
  const params = ReactRouter.useParams()
  const page = params && params[0]
  const theme = EmotionTheming.useTheme()

  return (
    <Theming.Alternative>
      <Common.Box pt={0} flexGrow={[null, '1']} display={[null, 'flex']}>
        <SupportChatActionButton />
        <Common.Box
          display="flex"
          backgroundColor="card-background"
          backgroundImage={[
            `url(${theme['bg-pattern-stripe-small']}),
            linear-gradient(to bottom, ${theme.colors['page-gradient-start']} 150px,
            ${theme.colors['page-gradient-middle']} 250px, ${theme.colors['page-gradient-stop']} 575px)`,
            null,
            `url(${theme['bg-pattern-stripe-large']}),
              linear-gradient(to bottom, ${theme.colors['page-gradient-start']} 150px,
              ${theme.colors['page-gradient-middle']} 250px, ${theme.colors['page-gradient-stop']} 575px)`,
          ]}
          backgroundRepeat="no-repeat"
          backgroundPosition="left top"
          p={[1, null, 4]}
          justifyContent="center"
          alignItems="flex-start"
          fontSize={2}
          minHeight="100%"
          flexGrow={[null, '1']}
        >
          <Card p={[2, 4]} width="100%" maxWidth={[null, null, null, '1000px']}>
            <HtmlContent
              html={{
                __html: i18n.translate(`faq.${page}.content`),
              }}
            />
          </Card>
        </Common.Box>
      </Common.Box>
    </Theming.Alternative>
  )
}

export default FaqPage
